<template>
    <div id="timer" class="no-wrap timer-k">
        <vue-countdown-timer
            @end_callback="timeEnd('event ended')"
            :start-time="startTime"
            :end-time="endTime"
            :interval="1000"
            label-position="begin"
            :end-text="trans('Time ended')"
            :showDay="true"
            hour-txt=":"
            minutes-txt=":"
            seconds-txt="">
            <template slot="countdown" slot-scope="scope">
                <span>{{scope.props.hours}}</span><i>{{scope.props.hourTxt}}</i>
                <span>{{scope.props.minutes}}</span><i>{{scope.props.minutesTxt}}</i>
                <span>{{scope.props.seconds}}</span><i>{{scope.props.secondsTxt}}</i>
            </template>
        </vue-countdown-timer>
    </div>
</template>

<script>
export default {
    name: "Timer",
    methods: {
        timeEnd() {
            this.onConfirmHandler();
        }
    },

    computed: {
        startTime() {
            return new Date();
        },

        endTime() {
            const date = new Date();
            return new Date(date.getTime() + this.activeQuiz.time_limit * 60000);
        },
    }
}
</script>

<style scoped>

</style>
